import React, { useState } from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import SMFacilitiesList from '../../stateless/SMFacilitiesList';
import SMFacilitiesMap from '../SMFacilitiesMap';
import styles from './styles.scss';
import StateFeeDisplay from '../../stateless/StateFeeDisplay';

const propTypes = {
  facilities: PropTypes.arrayOf(
    PropTypes.shape({
      location: PropTypes.shape({
        coordinates: PropTypes.arrayOf(
          PropTypes.number,
        ).isRequired,
      }).isRequired,
    }).isRequired,
  ).isRequired,
  initialCenter: PropTypes.shape({
    latitude: PropTypes.number.isRequired,
    longitude: PropTypes.number.isRequired,
  }),
  initialZoom: PropTypes.number,
  multiLocale: PropTypes.bool,
};

const defaultProps = {
  initialCenter: undefined,
  initialZoom: undefined,
  multiLocale: false,
};

const SMFacilitiesListWithMap = ({
  facilities,
  initialCenter,
  initialZoom,
  multiLocale,
  ...rest
}) => {
  const [hoveredFacility, setHoveredFacility] = useState();
  const [focusedFacility, setFocusedFacility] = useState();

  const [center, setCenter] = useState(initialCenter);

  const clearFocusedFacility = () => {
    setFocusedFacility();
  };

  const setAndCenterFocusedFacility = (facility) => {
    const [longitude, latitude] = facility.location.coordinates;

    setFocusedFacility(facility);
    setCenter({ latitude, longitude });
  };

  return (
    <div>
      <StateFeeDisplay facilityStates={facilities.map(f => f.address.state)} />
      <div className={`relative flex flex-col-reverse md:flex-row md:overflow-hidden md:sticky ${styles.listingHeight}`}>
        <div className="bg-white py-4 md:pt-0 md:pb-0 md:w-3/5 min-[950px]:w-3/5 w-full z-10">
          <div className="md:h-full md:p-3 pb-10 md:pb-[200px] md:overflow-y-auto">
            <SMFacilitiesList
              {...rest}
              activeFacility={hoveredFacility}
              facilities={facilities}
              multiLocale={multiLocale}
              onItemHover={setHoveredFacility}
            />
          </div>
        </div>
        <SMFacilitiesMap
          activeFacility={hoveredFacility}
          center={center}
          facilities={facilities}
          focusedFacility={focusedFacility}
          multiLocale={multiLocale}
          onMapClick={clearFocusedFacility}
          onPopupDismiss={clearFocusedFacility}
          onMarkerClick={setAndCenterFocusedFacility}
          onMarkerHover={setHoveredFacility}
        />
      </div>
    </div>
  );
};

SMFacilitiesListWithMap.propTypes = propTypes;
SMFacilitiesListWithMap.defaultProps = defaultProps;

SMFacilitiesListWithMap.fragments = {
  facility: gql`
      fragment SMFacilitiesListWithMapFacility on Facility {
        id
      ...SMFacilitiesListFacility
      ...SMFacilitiesMapFacility
    }

      ${SMFacilitiesList.fragments.facility}
      ${SMFacilitiesMap.fragments.facility}
      `,
};

export default SMFacilitiesListWithMap;
